const {
  parseVolNumFromTitleString,
  resolveCatalogVolNum,
  applyGuestCatalogProgressPolicy,
} = require('../../../../scripts/lib/catalogVolNum.cjs')

export { parseVolNumFromTitleString, resolveCatalogVolNum, applyGuestCatalogProgressPolicy }
